import React from 'react'
import { Fade } from 'react-reveal'
import ImageBlock from '../shared-page-components/image-block.js'
import HalfImageBlock from '../shared-page-components/half-image-block.js'
import TextBlock from '../shared-page-components/text-block.js'
import CareersLinks from '../shared-page-components/careers-links.js'
import Carousel from '../shared-page-components/carousel.js'
import Quote from '../shared-page-components/quote.js'
import Video from '../shared-page-components/video.js'
import VideoMutedAutoplay from '../shared-page-components/video-muted-autoplay.js'
import TwoImageBlock from '../shared-page-components/two-image-block.js'
import ItemListBlock from '../shared-page-components/item-list-block.js'
import ClientLogoGrid from '../shared-page-components/client-logo-grid.js'
import Accordion from '../shared-page-components/accordion.js'

export function renderComponent(component, i) {
  if (
    component.__typename === 'ContentfulComponentImageBlock' ||
    component.__typename === 'ContentfulFeatureComponentImageBlock'
  ) {
    return (
      <Fade key={`Fade_ImageBlock_${i}`}>
        <ImageBlock key={`ImageBlock_${i}`} component={component} />
      </Fade>
    )
  }

  if (
    component.__typename === 'ContentfulComponentHalfImageBlock' ||
    component.__typename === 'ContentfulFeatureComponentHalfImageBlock'
  ) {
    return (
      <Fade key={`Fade_HalfImageBlock_${i}`}>
        <HalfImageBlock key={`HalfImageBlock_${i}`} component={component} />
      </Fade>
    )
  }

  if (component.__typename === 'ContentfulComponentCarousel') {
    return <Carousel key={`Carousel_${i}`} component={component} />
  }

  if (component.__typename === 'ContentfulComponentQuote') {
    return (
      <Fade key={`Fade_Quote_${i}`}>
        <Quote key={`Quote_${i}`} component={component} />
      </Fade>
    )
  }

  if (component.__typename === 'ContentfulComponentTextBlock') {
    return (
      <Fade key={`Fade_TextBlock_${i}`}>
        <TextBlock key={`TextBlock_${i}`} component={component} />
      </Fade>
    )
  }

  if (component.__typename === 'ContentfulComponentCareersLinks') {
    return (
      <Fade key={`Fade_CareersLinks_${i}`}>
        <CareersLinks key={`CareersLinks_${i}`} component={component} />
      </Fade>
    )
  }

  if (component.__typename === 'ContentfulComponentVideoClickToPlay') {
    return (
      <Fade key={`Fade_Video_${i}`}>
        <Video key={`Video_${i}`} component={component} />
      </Fade>
    )
  }

  if (component.__typename === 'ContentfulComponentVideoMutedAutoplay') {
    return (
      <Fade key={`Fade_VideoMutedAutoplay_${i}`}>
        <VideoMutedAutoplay
          key={`VideoMutedAutoplay_${i}`}
          component={component}
        />
      </Fade>
    )
  }

  if (component.__typename === 'ContentfulFeatureComponentTwoImageBlock') {
    return (
      <Fade key={`Fade_TwoImageBlock_${i}`}>
        <TwoImageBlock key={`TwoImageBlock_${i}`} component={component} />
      </Fade>
    )
  }

  if (component.__typename === 'ContentfulComponentItemListBlock') {
    return (
      <Fade key={`Fade_ItemListBlock_${i}`}>
        <ItemListBlock key={`ItemListBlock_${i}`} component={component} />
      </Fade>
    )
  }

  if (component.__typename === 'ContentfulGridComponentClientLogoGrid') {
    return (
      <Fade key={`Fade_ClientLogoGrid_${i}`}>
        <ClientLogoGrid key={`ClientLogoGrid_${i}`} component={component} />
      </Fade>
    )
  }

  if (component.__typename === 'ContentfulComponentAccordion') {
    function addColorsToComponents(item) {
      item.primaryColor = component.primaryColor
      item.secondaryColor = component.secondaryColor
      item.backgroundColor = component.backgroundColor
    }

    component.linkedComponents.map(item => {
      return addColorsToComponents(item)
    })

    return (
      <Accordion
        key={`Accordion_${i}`}
        primaryColor={component.primaryColor}
        secondaryColor={component.secondaryColor}
        backgroundColor={component.backgroundColor}
        marginBelow={component.marginBelow}
        panels={[
          {
            label: <h2>{component.label}</h2>,
            closeLabel: <h2>{component.closeLabel}</h2>,
            content: component.linkedComponents.map((item, i) => {
              return renderComponent(item, 'accordion-' + i)
            }),
          },
        ]}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/render-components.js